<template>
    <div class="container-fluid animated fadeIn page-content">
        <SectionTitle :title="'Thống kê tình hình các trạm đo lượng mưa'" />
        <hooper :settings="hooperSettings">
            <slide v-for="(item, index) in listStationRainDisplay" :key="index" :index="index">
                <b-card border-variant="light" class="card-doc mx-2">
                    <b-card-title
                        :class="[
                            'text-secondary',
                            isMobile ? 'font-15' : 'font-18',
                            'font-weight-bold'
                        ]"
                        >{{ item.name.replace('Trạm đo mưa', '').replace('xã', '') }}</b-card-title
                    >
                    <b-row align-v="center">
                        <b-col cols="3">
                            <div class="station-icon">
                                <i class="fa fa-tint fa-lg text-white" />
                            </div>
                        </b-col>
                        <b-col cols="9" class="station-name">{{
                            `${mapCurrentWater[item.code] ? mapCurrentWater[item.code] : 0} mm/h`
                        }}</b-col>
                    </b-row>
                    <b-card-text class="text-muted mt-3">{{
                        getRainStatus(mapCurrentWater[item.code])
                    }}</b-card-text>
                </b-card>
            </slide>
        </hooper>

        <SectionTitle class="mt-3" :title="'Thống kê tình hình các trạm đo mực nước'" />
        <hooper :settings="hooperSettings">
            <slide v-for="(item, index) in listStationWaterDisplay" :key="index" :index="index">
                <b-card border-variant="light" class="card-doc mx-2">
                    <b-card-title
                        :class="[
                            'text-secondary',
                            isMobile ? 'font-15' : 'font-18',
                            'font-weight-bold'
                        ]"
                        >{{
                            item.name.replace('Trạm đo mực nước', '').replace('xã', '')
                        }}</b-card-title
                    >
                    <b-row align-v="center">
                        <b-col cols="3">
                            <div class="station-icon">
                                <i class="fa fa-tint fa-lg text-white" />
                            </div>
                        </b-col>
                        <b-col cols="9" class="station-name">{{
                            `${mapCurrentWater[item.code] ? mapCurrentWater[item.code] : 0} m`
                        }}</b-col>
                    </b-row>
                    <b-card-text class="text-muted mt-3">{{
                        getWaterStatus(mapCurrentWater[item.code])
                    }}</b-card-text>
                </b-card>
            </slide>
        </hooper>

        <SectionTitle class="mt-3" :title="'Bản đồ cảnh báo lũ hôm nay'" />
        <Map :gestureHandling="true" />

        <div v-if="!isMobile">
            <SectionTitle :title="'Thống kê so sánh dữ liệu giữa các trạm'" class="mt-5" />
            <CompareChart />
        </div>

        <SectionTitle class="mt-4" :title="'Văn bản chỉ đạo'" />
        <div class="text-center" v-if="!listDocsDisplay.length">Không có bản ghi nào</div>
        <b-row v-else class="mt-4 mx-1">
            <b-col
                sm="6"
                md="4"
                lg="3"
                xl="3"
                v-for="(item, index) in listDocsDisplay"
                :key="index"
            >
                <b-card border-variant="light" class="card-doc">
                    <b-card-title
                        class="text-primary font-15 font-weight-bold cursor-pointer document-content"
                        @click="getInfo(item.id)"
                        >{{ item.name }}</b-card-title
                    >
                    <b-card-text class="document-content" v-html="item.content" />
                    <b-card-text class="text-muted">{{
                        $moment(item.createdAt).format('DD/MM/YYYY')
                    }}</b-card-text>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle';
import { mapState, mapActions } from 'vuex';
import { Hooper, Slide } from 'hooper';
import Map from '@/components/Map';
import RDateTimePicker from '@/components/RDateTimePicker';
import CompareChart from '@/components/CompareChart';

import 'hooper/dist/hooper.css';
export default {
    components: {
        SectionTitle,
        Hooper,
        Slide,
        Map,
        RDateTimePicker,
        CompareChart
    },
    data() {
        return {
            hooperSettings: {
                itemsToShow: 4,
                autoPlay: true,
                infiniteScroll: true,
                playSpeed: 3000,
                breakpoints: {
                    350: {
                        centerMode: false,
                        itemsToShow: 2
                    },
                    800: {
                        centerMode: false,
                        itemsToShow: 3
                    },
                    1200: {
                        centerMode: false,
                        itemsToShow: 4
                    },
                    1400: {
                        itemsToShow: 6,
                        pagination: 'fraction'
                    }
                }
            }
        };
    },
    computed: {
        ...mapState({
            items: (state) => state.station.items,
            listDocs: (state) => state.news.items,
            listWaterEachStation: (state) => state.station.listWater,
            isMobile: (state) => state.page.isMobile
        }),
        listStationRainDisplay() {
            return this.items.filter((item) => item.code.includes('F00'));
        },
        listStationWaterDisplay() {
            return this.items.filter((item) => item.code.includes('F01'));
        },
        mapCurrentWater() {
            const waterValue = {};
            this.listWaterEachStation.forEach((element) => {
                if (element.stationCode.includes('F01'))
                    waterValue[element.stationCode] = this.isMobile
                        ? (element.value / 100).toFixed(1)
                        : (element.value / 100).toFixed(2);
                else waterValue[element.stationCode] = element.value;
            });
            return waterValue;
        },
        listDocsDisplay() {
            let listDocs = this.listDocs.filter((item) => item.type == 'DOCUMENT');
            return listDocs.reverse().slice(0, 4);
        }
    },
    methods: {
        ...mapActions({
            getListStation: 'station/getList',
            getListStationWater: 'station/getListStationWater',
            getListDocs: 'news/getList'
        }),
        getWaterStatus(value) {
            value = (value / 100).toFixed(2);
            return value > 70 ? 'Cao' : value > 50 ? 'Trung bình' : 'Thấp';
        },
        getRainStatus(value) {
            return value > 20
                ? 'Mưa rất to'
                : value > 10
                ? 'Mưa to'
                : value > 5
                ? 'Mưa vừa'
                : value > 0
                ? 'Mưa nhỏ'
                : 'Không mưa';
        },
        getRainVariantColor(value) {
            let data = this.mapCurrentWater[value];
            return data > 20
                ? 'danger'
                : data > 10
                ? 'warning'
                : data > 5
                ? 'secondary'
                : data > 0
                ? 'info'
                : 'primary';
        },
        getWaterVariantColor(value) {
            let data = this.mapCurrentWater[value];
            data = (data / 100).toFixed(2);
            return data > 70 ? 'danger' : data > 50 ? 'warning' : 'primary';
        },
        getInfo(newsId) {
            this.$router.push(`/news/${newsId}`);
        }
    },
    created() {
        this.getListStation();
        this.getListDocs();
        this.getListStationWater({
            date: this.$moment().format('DD/MM/YYYY'),
            hour: this.$moment().format('HH')
        });
    }
};
</script>
<style lang="scss" scoped>
</style>
